<template>
  <div>
    <CRow class="mb-4">
      <CCol>
        <p class="text-2xl">Halo, Selamat Datang</p>
        <p class="text-lg capitalize">
          {{ namaUnit }}
        </p>
      </CCol>
    </CRow>

    <WidgetsDropdown class="mb-2" :data="dashData" />

    <!-- <CRow class="mb-4">
      <CCol md="12" lg="8">
        <h2 class="text-center mb-2 text-lg">Penyebab</h2>
        <VueApexChart
          type="bar"
          :options="chartBarOptions"
          :series="barSeries"
        />
      </CCol>
      <CCol md="12" lg="4" class="">
        <h2 class="text-center mb-2 text-lg">Persentase Saldo TL & TPB</h2>
        <VueApexChart
          type="donut"
          :options="chartPieOptions"
          :series="pieSeries"
        />
        <VueApexChart
          type="donut"
          :options="chartPieOptions"
          :series="pieSeries"
        />
      </CCol>
    </CRow> -->

    <!-- <SamplePDF class="mb-4" /> -->
    <!-- <TpTiga /> -->
  </div>
</template>

<script>
import WidgetsDropdown from "@/components/Widgets/WidgetsDropdown.vue";
// import SamplePDF from '@/components/Reports/ReportLevel1.vue';
// import TpTiga from '@/components/Reports/TpTiga.vue';
import axios from "axios";

export default {
  name: "Dashboard",
  components: {
    WidgetsDropdown,
    // SamplePDF,
    // TpTiga,
  },
  data() {
    return {
      namaUnit: "",
      dashData: "",
      pieSeries: [20, 80],
      chartPieOptions: {
        plotOptions: {
          pie: {
            donut: {
              size: "50%",
            },
          },
        },
        title: {
          text: "Kejadian",
          style: {
            fontSize: "14px",
            fontWeight: "medium",
          },
        },
        chart: {
          type: "donut",
          zoom: {
            enabled: false,
          },
        },
        colors: ["#FF4560", "#008FFB"],
        labels: ["Saldo TPB", "Tindak Lanjut"],
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "14px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: "bold",
          },
          background: {
            enabled: false,
          },
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 1,
            color: "#000",
            opacity: 0.3,
          },
        },
        legend: {
          position: "right",
        },
      },
      barSeries: [
        {
          data: [400, 430, 448, 470, 540, 580, 690, 1100, 1200, 1380],
        },
      ],
      chartBarOptions: {
        chart: {
          type: "bar",
        },

        plotOptions: {
          bar: {
            borderRadius: 2,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: [
            "South Korea",
            "Canada",
            "United Kingdom",
            "Netherlands",
            "Italy",
            "France",
            "Japan",
            "United States",
            "China",
            "Germany",
          ],
        },
      },
    };
  },
  async mounted() {
    this.$store.commit("ui/setTitleHeader", "Dashboard");
    await this.loadDashboardData();

    const result = localStorage.getItem("namaUnit");
    this.namaUnit = result.toLowerCase();
  },
  methods: {
    async loadDashboardData() {
      const response = await axios({
        method: "GET",
        baseURL: this.$apiAddress,
        url: "/api/dashboard",
        params: {
          token: localStorage.getItem("api_token"),
        },
      });

      if (response.status == 200) {
        this.dashData = await response.data;
      } else {
        this.toastError("Gagal load data dashboard");
      }
    },
  },
};
</script>
